import React from 'react';
import Skeleton from 'react-loading-skeleton';

const ActivitySkeleton = () => {
    return <div className="w-[100%] h-[24px] rounded-[4px] bg-[#e9f0f3]"></div>;
};

export default ActivitySkeleton;
